const project_list = [
  {
    title: "InnoVision Website",
    description: "The official website for the international conference, InnoVision, highlighting the event details.",
    category: "web dev",
    tech: ["Figma", "Next.js"],
    img: "../projects/Innovision_snapshot.png",
    links: {
      demo: "",
      github: ""
    }
  },
  {
    title: "Hangman Game",
    description: "A console-based Hangman game that allows users to guess words with a limited number of attempts.",
    category: "game dev",
    tech: ["C++", "OOP"],
    img: "../projects/hangman_snapshot.png",
    links: {
      demo: "",
      github: "https://github.com/renee-kh4n/Hangman-Cpp/"
    }
  },
  {
    title: "Rot Cypher",
    description: "A Python program that encodes and decodes messages using a basic rotational cipher (Caesar cipher).",
    category: "cryptography",
    tech: ["Python"],
    img: "../projects/rotcipher_snapshot.png",
    links: {
      demo: "",
      github: "https://github.com/renee-kh4n/rot-cipher"
    }
  },
  {
    title: "L33t C0nv3rt3r",
    description: "A Leet (L33T) speak converter written in C, with logic executed through assembly language integration.",
    category: "cryptography",
    tech: ["ASM", "C"],
    img: "../projects/leet_snapshot.png",
    links: {
      demo: "",
      github: "https://github.com/renee-kh4n/L33T-converter-C-ASM"
    }
  },
  {
    title: "Food Delivery System",
    description: "A console-based simulation of a food delivery system, handling operations for customers, managers, and cooks.",
    category: "systems project",
    tech: ["C"],
    img: "../projects/cFoodDelivery_snapshot.png",
    links: {
      demo: "",
      github: ""
    }
  },
  {
    title: "Payroll System",
    description: "A basic payroll processing system developed for an Advanced Programming course using R.",
    category: "systems project",
    tech: ["R"],
    img: "../projects/rPayroll_snapshot.png",
    links: {
      demo: "",
      github: "https://github.com/renee-kh4n/R_payrollSystem"
    }
  },
  {
    title: "Discovering Turtle",
    description: "An exploratory project that uses Python’s Turtle library to draw shapes and animations.",
    category: "graphics",
    tech: ["Python", "Turtle.py"],
    img: "../projects/turtle_snapshot.png",
    links: {
      demo: "",
      github: ""
    }
  },
  {
    title: "Hogwarts Website",
    description: "A website for Harry Potter Fans to explore and learn more about Hogwarts, the Houses, and Harry Potter characters. ",
    category: "UI/UX",
    tech: ["Figma"],
    img: "../projects/hogwarts_snapshot.png",
    links: {
      demo: "https://www.figma.com/proto/bqo7MsjOWbyWyZen66RTHb/Harry-Potter-Website?node-id=2-45&p=f&t=9bAXU3anfynFH11z-8&scaling=scale-down-width&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=2%3A45&hide-ui=1",
    }
  },
  {
    title: "Food Finder",
    description: "A mobile app prototype that offers users a one-stop platform for discovering recipes, groceries, and restaurants.",
    category: "UI/UX",
    tech: ["Figma"],
    img: "../projects/figmaFoodMobile_snapshot.png",
    links: {
      demo: "https://www.figma.com/proto/xU2uDnRKSIB8nJO4SOiB29/FOOD-FINDER---food-delivery-app?node-id=5-9&starting-point-node-id=5%3A9",
    }
  },
  {
    title: "Velvet Brew Cafe",
    description: "A desktop website prototype for a fictional cafe.",
    category: "UI/UX",
    tech: ["Figma"],
    img: "../projects/cafe_snapshot.png",
    links: {
      demo: "https://www.figma.com/proto/jwCdLpYud8jyYiTAp2P0KA/Cafe-Website?node-id=1-3&hide-ui=1&t=qxd0gCoRANn56jOI-8",
    }
  },
  {
    title: "Garden Grace Plant Website",
    description: "A desktop website prototype for plant care and shopping.",
    category: "UI/UX",
    tech: ["Figma"],
    img: "../projects/figmaPlant_snapshot.png",
    links: {
      demo: "https://www.figma.com/proto/p1RMvKRcJcqsP4oo67OrCL/Plant-Website?node-id=1-2",
    }
  },
  {
    title: "Doughnuts Website",
    description: "A simple and clean website design focused on showcasing a doughnut store.",
    category: "UI/UX",
    tech: ["Figma"],
    img: "../projects/figmaDoughnut_snapshot.png",
    links: {
      demo: "https://www.figma.com/proto/I5E14ZTAtThnqrkSiIXFNg/Renee-s-Doughnuts-Website?node-id=22-229",
    }
  },
  {
    title: "YouTube Replica",
    description: "A front-end clone of YouTube’s interface, focusing on the layout and functionality of the video-playing page.",
    category: "frontend dev",
    tech: ["HTML", "CSS", "JavaScript"],
    img: "../projects/ytReplica_snapshot.png",
    links: {
      demo: "",
      github: "https://github.com/renee-kh4n/Youtube-replica-mini-project"
    }
  }
];

export default project_list;
